import React from 'react';
import CoopCursorBorder from './coop-cursor-border';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

interface HistoryCursorBorderProps {
    element: IElementBaseModel;
    historyManager: IHistoryManager;
}

class HistoryCursorBorder extends React.Component<HistoryCursorBorderProps> {
    public render() {
        if (!this.props.historyManager?.isShowHistoryPanel) {
            return null;
        }
        const authorInfo = this.getAuthInfo();
        if (!authorInfo) {
            return null;
        }
        const { element } = this.props;
        if (element.type === UIModelType.CONNECTOR) {
            return null;
        }
        const hexColor = this.props.historyManager?.getColorForId(authorInfo);
        const { width, height } = element.props.style;

        const innerRect = {
            width,
            height,
        };
        return (
            <CoopCursorBorder
                size={innerRect}
                color={hexColor}
                shouldRoundSize={element.type === UIModelType.SHAPE
                || element.type === UIModelType.IMAGE}
            />
        );
    }

    private getAuthInfo() {
        const { changedComponents } = this.props.historyManager;
        if (changedComponents.length === 0) {
            return null;
        }
        const changedComponent = changedComponents
            .find(item => item.components?.has(this.props.element.sdkData?.props.id));
        return changedComponent?.author || null;
    }
}

export default HistoryCursorBorder;
